// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "business.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "business.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class Business$Type extends MessageType {
    constructor() {
        super("Business", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 102, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 103, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 104, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.isActive = false;
        message.createdAt = "";
        message.updatedAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool is_active */ 3:
                    message.isActive = reader.bool();
                    break;
                case /* string created_at */ 4:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 5:
                    message.updatedAt = reader.string();
                    break;
                case /* repeated string field_mask */ 100:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 101:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 102:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 103:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 104:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool is_active = 3; */
        if (message.isActive !== false)
            writer.tag(3, WireType.Varint).bool(message.isActive);
        /* string created_at = 4; */
        if (message.createdAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 5; */
        if (message.updatedAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.updatedAt);
        /* repeated string field_mask = 100; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(100, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 101; */
        if (message.pageNumber !== 0)
            writer.tag(101, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 102; */
        if (message.orderBy !== "")
            writer.tag(102, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 103; */
        if (message.orderDir !== "")
            writer.tag(103, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 104; */
        if (message.withoutLimit !== false)
            writer.tag(104, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Business
 */
export const Business = new Business$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BusinessList$Type extends MessageType {
    constructor() {
        super("BusinessList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Business },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Business results */ 1:
                    message.results.push(Business.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Business results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Business.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BusinessList
 */
export const BusinessList = new BusinessList$Type();
/**
 * @generated ServiceType for protobuf service BusinessService
 */
export const BusinessService = new ServiceType("BusinessService", [
    { name: "Create", options: {}, I: Business, O: Business },
    { name: "Get", options: {}, I: Business, O: Business },
    { name: "BatchGet", options: {}, I: Business, O: BusinessList },
    { name: "Update", options: {}, I: Business, O: Business },
    { name: "Delete", options: {}, I: Business, O: Empty }
]);
